export const getTextErrors = (): Record<string, string> => {
  return {
    CODE_VERIFICATION_FAILED: 'Невірний код доступу, спробуйте ще раз',
    USER_BLOCKED: 'Ваш обліковий запис тимчасово заблоковано.',
    TOO_MANY_CODE_REQUESTS: 'Ви надто часто запитуєте код доступу. Спробуйте пізніше.',
    CAPTCHA_VERIFICATION_FAILED: 'Не вдалося підтвердити, що Ви не робот, спробуйте ще раз',
    SERVER_ERROR: 'Помилка сервера, звернітся до системного адміністратора'
  };
};

export const textError = getTextErrors();
